import React, { useEffect , useRef , useState } from 'react'
import  styles from '../scss/Main.module.scss'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Pagination , Navigation } from "swiper/modules";

import 'swiper/css';
import 'swiper/css/pagination';
//import '../../src/swiper.css';
import 'swiper/css/navigation';
import '../../src/swiper.css'
//import './styles.css';

const Main = () => {

let [slidenum,SetSlidenum] = useState(0);
const pointer = document.body.querySelector("#pointer");
const move = (e:any) => {
    if(pointer instanceof HTMLElement){
    pointer.style.top = (e.pageY -500) + "px"; 
    pointer.style.left = (e.pageX -500) + "px";
    }
}
const pagination = ["Intro","About","Skills","Projects","Contact"]


function getRandomValue(max: number): number {
    return Math.floor(Math.random() * max);
  }
  const windowWidth = window.screen.width;
  const windowHeight = window.screen.height;
  const x = getRandomValue(windowWidth);
  const y = getRandomValue(windowHeight);
  
  let [pronum,setPronum] = useState(99);
  const [active,setActive] = useState(true);
  const [swiperKey, setSwiperKey] = useState(0);
  const swiperRef:any = useRef(null);
  const swiperRef1:any = useRef(null);
  const [activeSlideIndex,setActiveSlideIndex] = useState(0);
  const [activeSlideIndex1,setActiveSlideIndex1] = useState(0);
  
  //스와이퍼멈춤기능
  const toggleMousewheel = (e:any) => {

    const currentSlideIndex = swiperRef.current.swiper.activeIndex;
    const currentSlideIndex1 = swiperRef1.current.swiper.activeIndex;
    setActiveSlideIndex(currentSlideIndex);
    setActiveSlideIndex1(currentSlideIndex1);
    if(e.target.offsetWidth === 20){
        setPronum(99);
        setActive(!active);
    }
    else{
        const nodes = [...e.target.parentElement.parentElement.children];
        const index = nodes.indexOf(e.target.parentElement);
        setPronum(index);
        setActive(!active);
        up("#project_box",0,1);
    }

    setSwiperKey((prevKey) => prevKey + 1);
  }
  //텍스트 효과
   const post_h1 = useRef<HTMLInputElement>(null);
   const textani = () => {
     if(post_h1.current !=null){
         const h1_child:any  = post_h1.current.children;
             for(var i=0;i<h1_child.length;i++){
               h1_child[i].style.opacity = 1;
               h1_child[i].style.visibility = "visible";
               h1_child[i].style.transform = "rotateY(0)";
               h1_child[i].style.transitionDelay = (i*0.15)+0.3+"s";
             }
       }
   }
   const untextani = () => {
    if(post_h1.current !=null){
        const h1_child:any  = post_h1.current.children;
            for(var i=0;i<h1_child.length;i++){
              h1_child[i].style.opacity = 0;
              h1_child[i].style.visibility = "hidden";
              h1_child[i].style.transform = "rotateY(-90deg)";
            }
      }
  }
  //작아지는 함수
  const scale = (id:any,num:string) => {
    let ele = document.querySelector<HTMLElement>(id);
    if(ele instanceof HTMLElement){
        ele.style.fontSize = num;
    }
  }
    //위로 올라오는 함수
    const up = (id:any,num:number,opacity:number) => {
        let ele = document.querySelector<HTMLElement>(id);
        if(ele instanceof HTMLElement){
            ele.style.transform = "translateY("+num+"px)"
            ele.style.opacity = String(opacity);

        }
    }
    //opacity
    const opacity = (id:any,num:number) => {
        let ele = document.querySelector<HTMLElement>(id);
        if(ele instanceof HTMLElement){
            ele.style.opacity = String(num);
        }
    }
    //클래스 넣다 빼기
    let class_num = 0;
    const [isSecON ,setIsSecON] = useState(0);
    const class_add = () => {
        let ele = document.querySelector<HTMLElement>("#shooting_star");
        if(ele instanceof HTMLElement){
            if(class_num === 0){
                class_num = 1;
                setIsSecON(class_num);
            }else{
                class_num = 0;
                setIsSecON(class_num);
            }
        }
    }
  useEffect(()=>{
    setInterval(class_add,5000);
    textani();
    //console.log(swiperRef.current.swiper.activeIndex);
    //스와이퍼 조작
    swiperRef.current.swiper.slideTo(activeSlideIndex,0);
    swiperRef1.current.swiper.slideTo(activeSlideIndex1,0);

    //별 조작
    const star = document.querySelectorAll<HTMLElement>("#point");
    for(var i=0; i<star.length; i++){
        star[i].style.top = String(getRandomValue(100))+"vh";
        star[i].style.left = String(getRandomValue(99))+"vw";
        star[i].style.animationDuration = String(getRandomValue(3)) + 's';
        star[i].style.animationDelay = String(getRandomValue(3)) + 's';
        star[i].style.animationDirection = "alternate";
        star[i].style.animationIterationCount = "infinite";
    }
    window.addEventListener("mousemove",(e:any)=>{
        const pointer = document.body.querySelector("#pointer");
        if(pointer instanceof HTMLElement){
            pointer.style.top = (e.pageY - 250) + "px"; 
            pointer.style.left = (e.pageX - 250) + "px";
            }

    });
    window.addEventListener("click",(e:any)=>{
        console.log(e.clientX);
        if(e.target.innerHTML === "Intro"){
            textani();
            //un
            opacity("#pro2_con",0);
            scale("#scale1","1.8rem");
            scale("#scale2","1.8rem");
            up("#skill_box1",100,0);
            up("#skill_box2",100,0);
            up("#project_box",300,0);
            up("#slide5_img_box",300,1);
        }else if(e.target.innerHTML === "About"){
            opacity("#pro2_con",1);
            //un
            untextani();
            scale("#scale1","1.8rem");
            scale("#scale2","1.8rem");
            up("#skill_box1",100,0);
            up("#skill_box2",100,0);
            up("#project_box",300,0);
            up("#slide5_img_box",300,1);
        }else if(e.target.innerHTML === "Skills"){
            if(window.innerWidth < 767){
                scale("#scale1","2.2vw");
                scale("#scale2","2.2vw");
            }else{
                scale("#scale1","1.4rem");
                scale("#scale2","1.4rem");
            }
            up("#skill_box1",0,1);
            up("#skill_box2",0,1);
            //un
            untextani();
            opacity("#pro2_con",0);
            up("#project_box",300,0);
            up("#slide5_img_box",300,1);
        }else if(e.target.innerHTML === "Projects"){
            up("#project_box",0,1);
            //un
            untextani();
            opacity("#pro2_con",0);
            scale("#scale1","1.8rem");
            scale("#scale2","1.8rem");
            up("#skill_box1",100,0);
            up("#skill_box2",100,0);
            up("#slide5_img_box",300,1);
        }else if(e.target.innerHTML === "Contact"){
            up("#slide5_img_box",30,1);
            //un
            untextani();
            opacity("#pro2_con",0);
            scale("#scale1","1.8rem");
            scale("#scale2","1.8rem");
            up("#skill_box1",100,0);
            up("#skill_box2",100,0);
            up("#project_box",300,0);
        }
    });
    window.addEventListener("wheel",(e:any)=>{
        
        if(swiperRef.current.swiper.activeIndex === 0){
            textani();
        }else{
            untextani();
        }
        if(swiperRef.current.swiper.activeIndex === 1){
            opacity("#pro2_con",1);
        }else{
            opacity("#pro2_con",0);
        }
        if(swiperRef.current.swiper.activeIndex === 2){
            if(window.innerWidth < 767){
                scale("#scale1","2.2vw");
                scale("#scale2","2.2vw");
            }else{
                scale("#scale1","1.4rem");
                scale("#scale2","1.4rem");
            }
            up("#skill_box1",0,1);
            up("#skill_box2",0,1);
        }else{
            scale("#scale1","1.8rem");
            scale("#scale2","1.8rem");
            up("#skill_box1",100,0);
            up("#skill_box2",100,0);
        }
        if(swiperRef.current.swiper.activeIndex === 3){
            up("#project_box",0,1);
        }else{
            up("#project_box",300,0);
        }
        if(swiperRef.current.swiper.activeIndex === 4){
            up("#slide5_img_box",30,1);
        }else{
            up("#slide5_img_box",300,1);
        }
        const wheel = document.body.querySelector("#slider1");
        if(wheel instanceof HTMLElement){
            let nodes:any = wheel?.parentElement?.children;
            for(var i=0; i<nodes.length; i++){
                //console.log(nodes[i].className);
                if(String(nodes[i].className.slice(-6)) === "active"){
                    SetSlidenum(i);
                    //console.log(slidenum);
                }
            }
        }
    });

},[active]);

  return (
    <>
        
        <div className={styles.wrap} id="wrap">
            <div className={styles.logo}>
                <img src={process.env.PUBLIC_URL+'/img/logo1.png'} />
            </div>
            <div className={styles.paginations}>
                <div className={slidenum === 0 ? styles.pagination_active : styles.pagination}></div>
                <div className={slidenum === 1 ? styles.pagination_active : styles.pagination}></div>
                <div className={slidenum === 2 ? styles.pagination_active : styles.pagination}></div>
                <div className={slidenum === 3 ? styles.pagination_active : styles.pagination}></div>
                <div className={slidenum === 4 ? styles.pagination_active : styles.pagination}></div>
            </div>
            <Swiper
            touchRatio={0}
            key={swiperKey}
            direction={"vertical"}
            speed={1000}
            slidesPerView={1}
            mousewheel={active}
            pagination={{
                clickable: true,
                renderBullet: function (index:number, className:string) {
                    return '<div class="' + className + '">' + pagination[index] + "</div>";
                  },
              }}
            ref={swiperRef}
            modules={[Mousewheel, Pagination]}
            className={styles.swiper}
            id='swiper'
            >
                <SwiperSlide className={styles.swiper_slide1} id="slider1">
                    <div className={styles.night}>
                        <div className={isSecON === 0 ? styles.shooting_star : styles.star} id="shooting_star"></div>
                    </div>
                    <div className={styles.point_box}>
                        <div className={styles.point} id="point"></div>
                        <div className={styles.point1} id="point"></div>
                        <div className={styles.point2} id="point"></div>
                        <div className={styles.point3} id="point"></div>
                        <div className={styles.point4} id="point"></div>
                        <div className={styles.point5} id="point"></div>
                        <div className={styles.point6} id="point"></div>
                        <div className={styles.point7} id="point"></div>
                        <div className={styles.point8} id="point"></div>
                        <div className={styles.point9} id="point"></div>
                        <div className={styles.point10} id="point"></div>
                        <div className={styles.point11} id="point"></div>
                        <div className={styles.point12} id="point"></div>
                        <div className={styles.point13} id="point"></div>
                        <div className={styles.point14} id="point"></div>
                        <div className={styles.point15} id="point"></div>
                        <div className={styles.point16} id="point"></div>
                        <div className={styles.point17} id="point"></div>
                        <div className={styles.point19} id="point"></div>
                        <div className={styles.point20} id="point"></div>
                        <div className={styles.point21} id="point"></div>
                        <div className={styles.point22} id="point"></div>
                        <div className={styles.point23} id="point"></div>
                        <div className={styles.point24} id="point"></div>
                        <div className={styles.point25} id="point"></div>
                        <div className={styles.point26} id="point"></div>
                        <div className={styles.point27} id="point"></div>
                        <div className={styles.point28} id="point"></div>
                        <div className={styles.point29} id="point"></div>
                        <div className={styles.point30} id="point"></div>
                        <div className={styles.point31} id="point"></div>
                        <div className={styles.point32} id="point"></div>
                        <div className={styles.point33} id="point"></div>
                        <div className={styles.point34} id="point"></div>
                        <div className={styles.point35} id="point"></div>
                        <div className={styles.point36} id="point"></div>
                        <div className={styles.point37} id="point"></div>
                        <div className={styles.point38} id="point"></div>
                        <div className={styles.point39} id="point"></div>
                        <div className={styles.point40} id="point"></div>
                        <div className={styles.point41} id="point"></div>
                        <div className={styles.point42} id="point"></div>
                    </div>
                    <div className={styles.content_box}>
                        <h1 ref={post_h1}>
                            <span>P</span>
                            <span>O</span>
                            <span>R</span>
                            <span>T</span>
                            <span>F</span>
                            <span>O</span>
                            <span>L</span>
                            <span>I</span>
                            <span>O</span>
                        </h1>
                        <h2>front end developer</h2>
                    </div>
                    <div className={styles.scroll_box}>
                        <span>SCROLL DOWN</span>
                        <img src={process.env.PUBLIC_URL+'/img/down-arrow.png'} />
                    </div>
                </SwiperSlide>
                <SwiperSlide className={styles.swiper_slide2}>
                    <div className={styles.slide2_box}>
                        <h1>ABOUT ME</h1>
                        <div className={styles.slide2_img_box}>
                            <div className={styles.slide2_img}></div>
                            <div className={styles.slide2_img_text}>
                                I'm ready
                            </div>
                        </div>
                        <div className={styles.slide2_con} id='pro2_con'>
                            <h1>"안녕하세요 실력있는 프론트엔드 개발자를 꿈꾸는 이예영입니다."</h1>
                            <p>많은 시행착오를 거쳐 제 오랜 꿈이였던 프론트엔드를 도전해보려고 합니다.</p>
                            <p>시간이 좀 걸린만큼 저의 새로운 도전을 더욱 소중히 여기고 열심히 시작해보려고 합니다.</p>
                            <p>창의적이고, 문제를 해결하는것을 좋아하는 저의 장점을 살려 겸손한 마음으로 </p>
                            <p>프론트엔드 개발자라는 새로운 길을 걸어보도록 하겠습니다!</p>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide className={styles.swiper_slide3}>
                <div className={styles.pointer} id="pointer"></div>
                    <h1>SKILLS</h1>
                    <p>* 아이콘에 마우스를 올리면 자세한 설명이 나옵니다.</p>
                    <div className={styles.slide3_box}>
                        <div className={styles.skill_box} id="skill_box1">
                            <div className={styles.skill_title}><p id="scale1">FRONT-END SKILLS</p></div>
                            <div className={styles.skill_img_box}>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/html5.png'} />
                                    <h6>HTML5</h6>
                                    <div className={styles.skill_text}>
                                        <h4>HTML5</h4>
                                        <p>웹접근성, 표준성을 준수하며 시멘틱태그를 이용해 마크업 할 수 있습니다.</p>
                                    </div>
                                </div>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/css3.png'} />
                                    <h6>CSS3</h6>
                                    <div className={styles.skill_text}>
                                        <h4>CSS</h4>
                                        <p>애니메이션을 만들수 있고, flex를 이용하여 반응형웹을 제작할 수 있습니다.</p>
                                    </div>
                                </div>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/sass.jpg'} />
                                    <h6>Sass</h6>
                                    <div className={styles.skill_text}>
                                        <h4>SCSS</h4>
                                        <p>SCSS 문법을 활용하여 CSS 코딩 속도를 높힐수 있습니다.</p>
                                    </div>
                                </div>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/jquery.png'} />
                                    <h6>Jquery</h6>
                                    <div className={styles.skill_text}>
                                        <h4>Jquery</h4>
                                        <p>관련 라이브러리와 애니메이션, 여러 메소드들을 잘 활용할 수 있습니다.</p>
                                    </div>
                                </div>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/js.png'}/>
                                    <h6>Javascript</h6>
                                    <div className={styles.skill_text}>
                                        <h4>Javascript</h4>
                                        <p>자바스크립트를 이용하여 DOM을 자유롭게 조작할 수 있습니다.</p>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.skill_img_box}>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/reactjs.png'} />
                                    <h6>React.js</h6>
                                    <div className={styles.skill_text}>
                                        <h4>React.js</h4>
                                        <p>요소들을 컴포넌트화 하여 재사용 할수 있고,생명주기에 대해 이해하고 있습니다. </p>
                                    </div>
                                </div>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/redux.png'} /> 
                                    <h6>Redux</h6>
                                    <div className={styles.skill_text}>
                                        <h4>Redux</h4>
                                        <p>데이터 상태관리를 통해 장바구니등 다양한 기능을 구현할 수 있습니다.</p>
                                    </div>
                                </div>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/ts.png'} />
                                    <h6>Typescript</h6>
                                    <div className={styles.skill_text}>
                                        <h4>Typescript</h4>
                                        <p>DOM을 조작하는데 있어 오류없이 TS를 구현할 수 있습니다.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.skill_box} id="skill_box2" style={{transition:"700ms ease 0.6s"}}>
                            <div className={styles.skill_title}><p id="scale2" style={{transition:"700ms ease 0.4s"}}>USING TOOL</p></div>
                            <div className={styles.skill_img_box}>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/vscode.png'} />
                                    <h6>VS CODE</h6>
                                    <div className={styles.skill_text}>
                                        <h4>VS CODE</h4>
                                        <p>주로 사용하는 프로그램이고 익숙한 코딩툴 입니다.</p>
                                    </div>
                                </div>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/git.png'} />
                                    <h6>GIT</h6>
                                    <div className={styles.skill_text}>
                                        <h4>GIT</h4>
                                        <p>명령어를 사용하여 레파지토리에 접근할 수 있고, 버전관리가 가능합니다.</p>
                                    </div>
                                </div>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/figma.jpg'} />
                                    <h6>Figma</h6>
                                    <div className={styles.skill_text}>
                                        <h4>Figma</h4>
                                        <p>데스크톱, 모바일 UI/UX 시안을 작업 할 수 있으며, 협업을 하는데 활용가능합니다.</p>
                                    </div>
                                </div>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/photoshop.png'} />
                                    <h6>PHOTOSHOP</h6>
                                    <div className={styles.skill_text}>
                                        <h4>PHOTOSHOP</h4>
                                        <p>마스크효과, 레이어 활용 등을 이용해 다양한 그래픽 요소를 제작할 수 있습니다.</p>
                                    </div>
                                </div>
                                <div className={styles.skill_img}>
                                    <img src={process.env.PUBLIC_URL+'/img/illustrator.png'} />
                                    <h6>Illustrator</h6>
                                    <div className={styles.skill_text}>
                                        <h4>Illustrator</h4>
                                        <p>펜툴 활용과 기타도구들을 이용해서 벡터 형식의 디자인 요소를 제작할 수 있습니다.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide className={styles.swiper_slide4}>
                    <div className={pronum === 0 ? styles.slide4_modal_on : styles.slide4_modal}>
                        <div className={styles.modal_con}>
                            <div className={styles.modal_header}>
                                <div className={styles.modal_logo}></div>
                                <div className={styles.modal_end} onClick={toggleMousewheel}></div>
                            </div>
                            <h1>그림 쇼핑몰사이트</h1>
                            <p>본프로젝트는 React,scss,redux를 사용하여 만든 쇼핑몰 웹사이트 입니다.<br /> 리액트 라우터를 사용하여 페이지를 이동하게 구현하였고, 각각은 컨포넌트화 하였습니다. <br />또한,상품 디테일 페이지는 리덕스를 활용하여 데이터의  상태관리를 구현하였습니다.<br/>웹 디자인같은 경우에는 많은 제품들을 한화면에 보여주기 보다는 <br />메인이 되는 그림 몇가지를 선정하여 사용자들이 한눈에 보기 싶도록 애니메이션을 추가하여 구성하였습니다. </p>
                            <div className={styles.gif1} style={{backgroundImage:'url("/img/project4_gif.gif")'}}></div>
                            <h1>상품 페이지</h1>
                            <p>redux를 활용한 페이지 입니다. 상세페이지에서 선택한 정보들은 redux로 넘겨주어 장바구니 페이지에서 출력합니다.<br />
                               간단한 삭제기능도 구현하였습니다.
                            </p>
                            <div className={styles.gif1} style={{backgroundImage:'url("/img/project4_gif2.gif")'}}></div>
                            <div className={styles.rink}>
                                <a href='https://yoang31.github.io/grimshop/' target="_blank">
                                    사이트 바로가기
                                </a>
                            </div>
                        </div>textani
                    </div>
                    <div className={pronum === 1 ? styles.slide4_modal_on : styles.slide4_modal}>
                        <div className={styles.modal_con}>
                            <div className={styles.modal_header}>
                                <div className={styles.modal_logo}></div>
                                <div className={styles.modal_end} onClick={toggleMousewheel}></div>
                            </div>
                            <h1>PORTFOLIO</h1>
                            <p>
                                본프로젝트는 React.js 와 TypeScript로 구현하여 만든 사이트 입니다.<br />
                                다양한 애니메이션을 javascript 와 css animation을 이용하여 만들었습니다.<br />
                            </p>
                            <div className={styles.gif1} style={{backgroundImage:'url("/img/project5_gif.gif")'}}></div>
                        </div>
                    </div>
                    <div className={pronum === 2 ? styles.slide4_modal_on : styles.slide4_modal}>
                        <div className={styles.modal_con}>
                            <div className={styles.modal_header}>
                                <div className={styles.modal_logo}></div>
                                <div className={styles.modal_end} onClick={toggleMousewheel}></div>
                            </div>
                            <h1>친환경캠페인 사이트</h1>
                            <p>팀프로젝트로 진행한 친환경 캠페인 사이트입니다.<br /> HTML , SCSS , Javascript로 구현하였습니다. 다양한 애니메이션 동작을 추가하였습니다.<br />
                            이 프로젝트를 진행하면서 css를 통한 애니메이션 동작들에 대해 많이 알게되었고, <br />화면의 구성, 반응형동작 방식에 대해 깊게 공부할 수 있었던 프로젝트입니다.
                            </p>
                            <div className={styles.gif1} style={{backgroundImage:'url("/img/team_pro_gif.gif")'}}></div>  
                            <h1>반응형</h1>
                            <p>반응형으로 제작하여 어떠한 환경에서도 사용가능합니다.
                            </p>
                            <div className={styles.gif1} style={{backgroundImage:'url("/img/team_pro_gif2.gif")', width:"380px" , height:"822px"}}></div>                        
                            <div className={styles.rink}>
                                <a href='https://yoang31.github.io/CodeCleaner/sub_climate.html' target="_blank">
                                    사이트 바로가기
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className={pronum === 3 ? styles.slide4_modal_on : styles.slide4_modal}>
                        <div className={styles.modal_con}>
                            <div className={styles.modal_header}>
                                <div className={styles.modal_logo}></div>
                                <div className={styles.modal_end} onClick={toggleMousewheel}></div>
                            </div>
                            <h1>API를 활용한 북스토어</h1>
                            <p>
                                카카오 오픈 API를 이용하였으며 직접 서버에서 책정보들을 가져와 저의 웹사이트에 활용하였습니다. 
                                <br />
                                이전까지는 정보들을 일일히 내가 직접 표현하는 방식만 사용하였으나 서버라는것을 배우고 더욱 정보를 다양하게 활용하는 법을 배웠습니다.
                            </p>
                            <div className={styles.gif1} style={{backgroundImage:'url("/img/project3_gif.gif")'}}></div>                        
                            <div className={styles.rink}>
                                <a href='https://yoang31.github.io/project3/' target="_blank">
                                    사이트 바로가기
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className={pronum === 4 ? styles.slide4_modal_on : styles.slide4_modal}>
                        <div className={styles.modal_con}>
                            <div className={styles.modal_header}>
                                <div className={styles.modal_logo}></div>
                                <div className={styles.modal_end} onClick={toggleMousewheel}></div>
                            </div>
                            <h1>자전거길 정보 사이트</h1>
                            <p>
                             본 프로젝트는 처음 javascript로 구현한 웹사이트입니다. js를 사용하여 DOM의 여러 요소들을 조작해 보았습니다.
                             <br />또한 반응형 작업을 하였으나, css 가 익숙하지 않아서 어려움을 겪었던 프로젝트 입니다.
                             <br />이 프로젝트를 기반으로 반응형작업에 대해 부족함을 느껴 그부분을 보완하고자 하였습니다.
                            </p>
                            <div className={styles.gif1} style={{backgroundImage:'url("/img/project2_gif.gif")'}}></div>                        
                            <div className={styles.rink}>
                                <a href='https://yoang31.github.io/kbicycle/' target="_blank">
                                    사이트 바로가기
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className={pronum === 5 ? styles.slide4_modal_on : styles.slide4_modal}>
                        <div className={styles.modal_con}>
                            <div className={styles.modal_header}>
                                <div className={styles.modal_logo}></div>
                                <div className={styles.modal_end} onClick={toggleMousewheel}></div>
                            </div> 
                            <h1>이탈리아 식당 사이트</h1>
                            <p>본 프로젝트는 제가 처음으로 만든 웹사이트입니다. HTML , SCSS , jquery로 구현하였습니다.
                            <br />HTML 파일과 css가 어떻게 연결되고 DOM 요소를 조작하면서 전반적인 흐름을 익혔습니다.
                            <br />추후 다른 웹사이트를 제작하는데 큰 틀을 만들어준 프로젝트였습니다.
                            </p>
                            <div className={styles.gif1} style={{backgroundImage:'url("/img/project1_gif.gif")'}}></div>                        
                            <h1>서브 페이지</h1>
                            <p>
                                서브페이지에서는 section에 이미지로 다양한 애니메이션 표현을 하였습니다.<br /> 애니메이션이 어떻게 동작하고 어떻게 구성되었는지 
                                알수 있었습니다.
                            </p>
                            <div className={styles.gif1} style={{backgroundImage:'url("/img/project1_gif1.gif")'}}></div>                        
                            <div className={styles.rink}>
                                <a href='https://yoang31.github.io/project_1/' target="_blank">
                                    사이트 바로가기
                                </a>
                                <a href='https://yoang31.github.io/project_1/index_2.html' target="_blank">
                                    서브 바로가기
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className={styles.slide4_box} id="slide4_box">
                        <div className={styles.slide4_title}>
                            <h1>PROJECT</h1>
                            <p>* 이미지를 클릭하면 자세한 내용 확인 가능합니다!</p>
                        </div>
                        <Swiper
                            touchRatio={1}
                            speed={500}
                            slidesPerView={1}
                            spaceBetween={30}
                            loop={true}
                            pagination={{
                            clickable: true,
                            }}
                            navigation={true}
                            modules={[Pagination, Navigation]}
                            className={styles.pro_sw}
                            ref={swiperRef1}
                            id="project_box"
                        >
                            <SwiperSlide className={styles.pjslider}>
                                <img className={styles.slide_img} src='/img/project4_1.JPG' onClick={toggleMousewheel} />
                                <div className={styles.tag}>
                                    <p># React.js</p><p># scss</p><p># Redux</p><p># 반응형</p>
                                </div>
                                <div className={styles.slide_con}>
                                    <h1>그림쇼핑몰</h1>
                                    <p>개인프로젝트</p>
                                    <p>
                                        그림을 판매하는 온라인쇼핑몰 입니다. 한국적인 디자인 요소들을 많이 넣었고, 한국화의 매력을 최대화 하기 위해 노력하였습니다.
                                    </p>
                                    <div className={styles.rink}>
                                        <a href='https://yoang31.github.io/grimshop/' target="_blank">사이트 바로가기</a>
                                    </div>
                                </div>
                                <div className={styles.slide_linkbutton}>

                                </div>
                            </SwiperSlide>
                            <SwiperSlide className={styles.pjslider}>
                                <img className={styles.slide_img} src='/img/project5_1.JPG' style={{border:"1px solid #fff"}} onClick={toggleMousewheel} />
                                <div className={styles.tag}>
                                    <p># React.js</p><p># scss</p><p># Typescript</p><p># 반응형</p>
                                </div>
                                <div className={styles.slide_con}>
                                    <h1>포트폴리오</h1>
                                    <p>개인프로젝트</p>
                                    <p>
                                        밤하늘의 별이라는 컨셉을 잡고 만든 개인 포트폴리오 사이트 입니다.
                                    </p>
                                    <div className={styles.rink}>
                                        <a href='#'>사이트 바로가기</a>
                                    </div>
                                </div>
                                <div className={styles.slide_linkbutton}>

                                </div>
                            </SwiperSlide>
                            <SwiperSlide className={styles.pjslider}>
                                <img className={styles.slide_img} src='/img/team_project.JPG' onClick={toggleMousewheel} />
                                <div className={styles.tag}>
                                    <p># HTML</p><p># scss</p><p># Javascript</p><p># 반응형</p>
                                </div>
                                <div className={styles.slide_con}>
                                    <h1>친환경캠페인 사이트</h1>
                                    <p>팀프로젝트</p>
                                    <p>환경에 대한 경각심을 불러 일으키려는 목표를 잡고 제작한 사이트입니다. 팀프로젝트이며 2명이 제작한 사이트 입니다.
                                    </p>
                                    <div className={styles.rink}>
                                        <a href='https://yoang31.github.io/CodeCleaner/' target="_blank">사이트 바로가기</a>
                                        <a href='https://yoang31.github.io/CodeCleaner/sub_climate.html' target="_blank">MYPART 바로가기</a>
                                    </div>
                                </div>
                                <div className={styles.slide_linkbutton}>

                                </div>
                            </SwiperSlide>
                            <SwiperSlide className={styles.pjslider}>
                            <img className={styles.slide_img} src='/img/project3_1.JPG' onClick={toggleMousewheel} />
                                <div className={styles.tag}>
                                    <p># HTML</p><p># Javascript</p><p># scss</p><p># Ajax</p><p># open API</p>
                                </div>
                                <div className={styles.slide_con}>
                                    <h1>API를 활용한 도서 웹사이트</h1>
                                    <p>개인프로젝트</p>
                                    <p>
                                        본사이트는 북스토어 웹사이트인 "바로보네"를 참고하여 만든 사이트입니다.
                                    </p>
                                    <div className={styles.rink}>
                                        <a href='https://yoang31.github.io/project3/' target="_blank">사이트 바로가기</a>
                                    </div>
                                </div>
                                <div className={styles.slide_linkbutton}>                               
                            </div>
                            </SwiperSlide>
                            <SwiperSlide className={styles.pjslider}>
                                <img className={styles.slide_img} src='/img/project2_1.JPG' onClick={toggleMousewheel} />
                                    <div className={styles.tag}>
                                        <p># HTML</p><p># Javascript</p><p># SCSS</p><p># jquery</p><p># 반응형</p>
                                    </div>
                                    <div className={styles.slide_con}>
                                        <h1>자전거 정보 웹사이트</h1>
                                        <p>개인프로젝트</p>
                                        <p>
                                            자전거길에 대한 정보를 제공하는 사이트로 정부가 운영하는 홈페이지를 참고하여 제작하였습니다.
                                        </p>
                                        <div className={styles.rink}>
                                            <a href='https://yoang31.github.io/kbicycle/' target="_blank">사이트 바로가기</a>
                                        </div>
                                    </div>
                                    <div className={styles.slide_linkbutton}>                               
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className={styles.pjslider}>
                                <img className={styles.slide_img} src='/img/project1_1.JPG' onClick={toggleMousewheel} />
                                    <div className={styles.tag}>
                                        <p># HTML</p><p># CSS</p><p># jquery</p>
                                    </div>
                                    <div className={styles.slide_con}>
                                        <h1>레스토랑 웹사이트</h1>
                                        <p>개인프로젝트</p>
                                        <p>
                                           이탈리아 식당사이트 입니다. 음식을 주로 소개하며, 다양한 메뉴들을 볼 수 있습니다.
                                        </p>
                                        <div className={styles.rink}>
                                            <a href='https://yoang31.github.io/project_1/' target="_blank">사이트 바로가기</a>
                                        </div>
                                    </div>
                                    <div className={styles.slide_linkbutton}>                               
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </SwiperSlide>
                <SwiperSlide className={styles.swiper_slide5}>
                    <div className={styles.slide5_box}>
                        <div className={styles.slide5_title}><h1>CONTACT</h1></div>
                        <div className={styles.slide5_con_box} id='slide5_con_box'>
                                <div className={styles.card_con}>
                                    <h2>Name : 이예영</h2>
                                    <h2>Mobile : 010 - 3476 - 7274</h2>
                                    <h2>Email : yoang31@naver.com</h2>
                                </div>
                        </div>
                        <div className={styles.slide2_img_text}>
                            ♡Thank you for reading♡
                        </div>
                        <div className={styles.slide5_img_box} id='slide5_img_box'>
                            <img src={process.env.PUBLIC_URL+'img/star_light.png'}/>
                            <img src={process.env.PUBLIC_URL+'img/star_light.png'}/>
                            <img src={process.env.PUBLIC_URL+'img/star_light.png'}/>
                            <img src={process.env.PUBLIC_URL+'img/star_light.png'}/>
                            <img src={process.env.PUBLIC_URL+'img/star_light.png'}/>
                            <img src={process.env.PUBLIC_URL+'img/star_light.png'}/>
                            <img src={process.env.PUBLIC_URL+'img/star_light.png'}/> 
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>    
                            <div className={styles.slide5_light} id='light'></div>    
                            <div className={styles.slide5_light} id='light'></div>    
                            <div className={styles.slide5_light} id='light'></div>    
                            <div className={styles.slide5_light} id='light'></div>    
                            <div className={styles.slide5_light} id='light'></div>    
                            <div className={styles.slide5_light} id='light'></div>    
                            <div className={styles.slide5_light} id='light'></div>    
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                            <div className={styles.slide5_light} id='light'></div>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    </>
  )
}

export default Main